<div *ngIf="isLoading()" class="loader-overlay">
    <div class="spinner"></div>
    </div>
